import type { ChangeRequest } from 'models';

export const getLastChangeRequestStatus = (changeRequests?: ChangeRequest[]) =>
  changeRequests?.toSorted((a, b) => a.createdAt.getTime() - b.createdAt.getTime())[changeRequests.length - 1]?.status;
